import React from "react";
import { createRoot } from "react-dom/client";
import EnquirySelectorIsland from "./EnquirySelectorIsland";

const mountNode = document.getElementById("enquiry-selector-island");

if (mountNode) {
  const rawConfig = mountNode.getAttribute("data-config");

  if (rawConfig) {
    const config = JSON.parse(rawConfig);
    createRoot(mountNode).render(<EnquirySelectorIsland config={config} />);
  }
}
